<template>
  <div class="mx-auto">
    <div class="minHeightMainContent flex-col">
      <div v-if="!loading">
        <CheckBox
          v-for="(val, ind) in settingsArray"
          :key="ind"
          class="mt-6"
          :title="ind"
          parent-module="section"
          :modules-array="val"
          :table-head-array="tableHeadArray"
          @updateSettings="getSettings"
        />
      </div>
      <Loader v-else class="mt-28" :content="true" />
    </div>
  </div>
</template>

<script>
/**
 * @notes IMPORTANT NOTES
 * index ACTION FOR VIEW
 * create ACTION FOR MARK
 *  */
/* COMPONENTS */
import CheckBox from '@src/components/Settings/attandance-settings/PermissionSettingsCheckbox.vue'
import { TENANT_ROLES } from '@src/constants/user-roles-constants.js'
import Loader from '@components/BaseComponent/Loader.vue'
import { removeExtraRolePermissions } from '@utils/permissions'

/* 3rd party Component */
import { mapActions, mapState } from 'vuex'

export default {
  components: {
    CheckBox,
    Loader,
  },
  page: {
    title: 'System Settings | Section Settings',
    meta: [
      {
        name: 'description',
        content: 'Section Settings',
      },
    ],
  },
  data: function () {
    return {
      settingsArray: [],
      tableHeadArray: ['Settings', 'View', 'Mark'],
      loading: false,
      excludeRoleSettings: [
        TENANT_ROLES.SECTION_ADMIN,
        TENANT_ROLES.SECTION_MODERATOR,
        TENANT_ROLES.CAMPUS_MODERATOR,
      ],
    }
  },

  computed: {
    ...mapState('layout', [
      'currentCampusScope',
      'currentSectionScope',
      'activeRole',
      'currentClassScope',
    ]),
  },
  watch: {
    currentCampusScope: {
      handler: function () {
        this.getSettings()
      },
      deep: true,
    },
    currentSectionScope: {
      handler: function () {
        this.getSettings()
      },
      deep: true,
    },
    activeRole: {
      handler: function () {
        this.getSettings()
      },
      deep: true,
    },
    currentClassScope: {
      handler() {
        this.getSettings()
      },
    },
  },
  mounted() {
    this.getSettings()
  },

  methods: {
    async getSettings() {
      this.loading = true
      const [res, err] = await this.getSectionSettings()
      removeExtraRolePermissions(this.excludeRoleSettings, res.data)

      this.settingsArray = res.data
      this.loading = false
    },
    ...mapActions('settings', ['getSectionSettings']),
  },
}
</script>
